import * as R from 'remeda';
import { createSelector } from 'reselect';
import { annotationSelector } from '../../redux/modules/annotation/selectors';
import { State } from '../../types/state';
import { resolveAnnotationDuplicates } from './helpers';

const relationsSelector = (state: State) =>
  state.annotation.sideloads.relations;

export const numberOfDuplicatesSelector = createSelector(
  annotationSelector,
  relationsSelector,
  (annotation, sideloadedRelations) => {
    if (!annotation) {
      return 0;
    }

    const duplicatesUrl = resolveAnnotationDuplicates(
      annotation.url,
      annotation.relations,
      sideloadedRelations
    );

    if (duplicatesUrl.length === 0) {
      return 0;
    }

    const relationsMap = new Map(
      sideloadedRelations.map(relation => [relation.url, relation])
    );

    const duplicateAnnotationsLength = R.pipe(
      duplicatesUrl,
      R.flatMap(url => relationsMap.get(url) ?? []),
      R.flatMap(r => r.annotations),
      R.unique(),
      R.length()
    );

    return duplicateAnnotationsLength;
  }
);
